/*
 * Mega Topbar behavior — self-contained custom element.
 * No shared state or event namespace with the existing main-nav JS.
 */
(function () {
  if (customElements.get('mega-topbar-5d')) return;

  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 200;

  class MegaTopbar extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.mega-topbar-5d-tab--has-panel'));
      this.isTouch = window.matchMedia('(hover: none)').matches;
      this.openTimer = null;
      this.closeTimer = null;

      this.tabs.forEach((tab) => {
        const link = tab.querySelector('.mega-topbar-5d-tab__link');
        const panelId = link ? link.getAttribute('aria-controls') : null;
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!link || !panel) return;

        if (this.isTouch) {
          link.addEventListener('click', (e) => {
            const isOpen = tab.classList.contains('mega-topbar-5d-tab--is-open');
            e.preventDefault();
            if (isOpen) {
              this.closeTab(tab, link, panel);
            } else {
              this.closeAll(tab);
              this.openTab(tab, link, panel);
            }
          });
        } else {
          tab.addEventListener('mouseenter', () => {
            clearTimeout(this.closeTimer);
            this.openTimer = setTimeout(() => {
              this.closeAll(tab);
              this.openTab(tab, link, panel);
            }, OPEN_DELAY);
          });

          tab.addEventListener('mouseleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.closeTab(tab, link, panel), CLOSE_DELAY);
          });

          // The panel is a sibling of the tab in the DOM (not nested inside it),
          // so moving the mouse from the tab down into the panel would otherwise
          // trigger the tab's mouseleave close-timer. Track hover on the panel
          // itself too, so the menu stays open while the cursor is over it.
          panel.addEventListener('mouseenter', () => {
            clearTimeout(this.closeTimer);
          });

          panel.addEventListener('mouseleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.closeTab(tab, link, panel), CLOSE_DELAY);
          });

          link.addEventListener('focus', () => {
            this.closeAll(tab);
            this.openTab(tab, link, panel);
          });
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAll();
          this.querySelector('.mega-topbar-5d-tab__link')?.focus();
        }
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.closeAll();
      });
    }

    openTab(tab, link, panel) {
      tab.classList.add('mega-topbar-5d-tab--is-open');
      link.setAttribute('aria-expanded', 'true');
      if (panel) panel.classList.add('mega-topbar-5d-panel--is-open');
    }

    closeTab(tab, link, panel) {
      tab.classList.remove('mega-topbar-5d-tab--is-open');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (panel) panel.classList.remove('mega-topbar-5d-panel--is-open');
    }

    closeAll(except) {
      this.tabs.forEach((tab) => {
        if (tab === except) return;
        const link = tab.querySelector('.mega-topbar-5d-tab__link');
        const panelId = link ? link.getAttribute('aria-controls') : null;
        const panel = panelId ? document.getElementById(panelId) : null;
        this.closeTab(tab, link, panel);
      });
    }
  }

  customElements.define('mega-topbar-5d', MegaTopbar);
})();